import { NGSWorkfileResponse } from './ngs-workfile-response';
import { NGSWorkfileRequest } from './ngs-workfile-request';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Machine } from '../masterdata/models/machine';
import { NgsVolumeAdjustmentService } from './ngs-volume-adjustment.service';
import { SelectableLab } from '../carrier/selectable-lab';
import { LiquidLevelDetectionRequest } from './liquid-level-detection-request';
import { LiquidConcentrationDetectionRequest } from './liquid-concentration-detection-request';
import { LiquidLevelDetectionResponse } from './liquid-level-detection-response';
import { FilePickerDirective, ReadFile, ReadMode } from 'ngx-file-helpers';
import { ErrorHandler } from "../utils/error-handler"
import { Carrier } from '../carrier/carrier';
import { MessagesService } from '../messages/messages.service';
import { MachineGeneratedFile } from './machine-generated-file';
import { CarrierUtility } from '../utils/carrier-utility';
import { ContainerItem } from '../carrier/carrieritem';
import { saveAs as saveByFileSaver } from "file-saver";
import { Sample } from '../carrier/sample';
import { NGSUpdateSampleRequestResponse } from './model/NGSUpdateSampleRequestResponse';
import { ContainerItemAware } from '../container-view/models/containerItem-aware';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-step-ngs-volume-adjustment',
  templateUrl: './ngs-volume-adjustment.component.html',
  styleUrls: ['./ngs-volume-adjustment.component.css'],
  providers: [DatePipe]
})
export class NgsVolumeAdjustmentComponent implements OnInit {

  carrierUtil: CarrierUtility = new CarrierUtility();

  readMode = ReadMode.text;
  lrsFileName: string;
  lrsFileContent: string;
  flxFileName: string;
  flxFileContent: string;
  status: string;

  createdBy: string;
  machineBarcode: string;

  liquidLevelDetectionForm: FormGroup;
  concentrationImportForm: FormGroup;
  errorHandler: ErrorHandler = new ErrorHandler;
  bufferShow = false;
  selectedLab: SelectableLab;

  fileReader: FileReader;

  liquidLevelDetctionResponse: LiquidLevelDetectionResponse;
  carriers: Carrier[];

  tableRows: number[];
  viewRest = false;
  sampleAmount: number = 0;
  bufferName: string;
  fillInVolume: number = 0;
  volumeProblems: number;
  assayType: string;
  statusText = '';
  myObj: any = { 'visibility': 'visible' };

  flxPlateBarcode = '';
  concentrationFile: string;
  ngsWorkfileRequest: NGSWorkfileRequest = new NGSWorkfileRequest();
  ngsWorkfileRespose: NGSWorkfileResponse = new NGSWorkfileResponse();
  numberOfMeasurements = 0;


  selectedSamples: ContainerItemAware[] = [];
  selectedSample: Sample;
  displayDialog: boolean;
  targetVolume: number;
  carriersOfSelectedSamples: Carrier[] = [];
 
  showConcentrationAdjustmentUI = false;
  showImportConcentrationUI = false;
  
  //for waiting spinner
  blocked: boolean;
  reMeasurementTag: boolean;
  reMeasurementSampleCount: number;
  reMeasurementFillVolume: number;

  @ViewChild('filePicker')
  private lrsFilePicker: FilePickerDirective;

  @ViewChild('filePicker')
  private flxFilePicker: FilePickerDirective;

  constructor(private datePipe: DatePipe, private formBuilder: FormBuilder, private ngsVolumeAdjustmentService: NgsVolumeAdjustmentService, private _messagesService: MessagesService) {
    this.selectedLab = JSON.parse(localStorage.getItem('lab'));
  }

  ngOnInit() {
    this.tableRows = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32];
    this.fileReader = new FileReader();

    this.liquidLevelDetectionForm = this.formBuilder.group({
      'createdBy': new FormControl('', Validators.required),
      'machineBarcode': new FormControl('', Validators.required),
      'lrsFileName': new FormControl('', Validators.required)
    });
    this.concentrationImportForm = this.formBuilder.group({
      'flxFileName': new FormControl('', Validators.required)
    });
}

  private barcodeFound(i: number, j: number, carrier: Carrier): boolean {
    return this.carrierUtil.barcodeFound(i, j, carrier);
  }

  //If sample not found, show in red and check for concentration required tag
  private barcodeNotFound(i: number, j: number, carrier: Carrier): string {
    if (this.carrierUtil.isConcentrationMeasurementRequired(i, j, carrier))
      return "barcodeNotFound-concentration-required";
    else if (!this.carrierUtil.isConcentrationMeasurementRequired(i, j, carrier))
      return "barcodeNotFound";
  }

  //Check if concentrationMeasurementRequired = false or true
  private barcodeFoundAndConcentrationMeasurementIsNotRequired(i: number, j: number, carrier: Carrier): string {
    if (this.carrierUtil.isConcentrationMeasurementRequired(i, j, carrier))
      return "barcodeFound-concentration-required";
    else if (!this.carrierUtil.isConcentrationMeasurementRequired(i, j, carrier))
      return "barcodeFound";
  }
  //Check if voulme is changed
  private targetVolumeHighlight(i: number, j: number, carrier: Carrier, any): string {
    if (this.getTargetVolumeChangeTag(i, j, carrier)) {
      return 'highlightTragetVolume';
    }
    else{
      return 'volumeNotChanged';
    }
  }

  notAllSamplesFoundOnConcentrationMeasurement(): boolean {
    if (this.liquidLevelDetctionResponse === undefined || this.liquidLevelDetctionResponse === null || this.liquidLevelDetctionResponse.allSamplesForConcentrationMeasurementFoundInDatabase === undefined || this.liquidLevelDetctionResponse.allSamplesForConcentrationMeasurementFoundInDatabase === null) {
      return false;
    }
    return !this.liquidLevelDetctionResponse.allSamplesForConcentrationMeasurementFoundInDatabase;
  }

  private boxHighlighting(i: number, j: number, carrier: Carrier): string {
    let sampleConcentration = this.getCarrierItemSampleConcentration(i, j, carrier);
    if (sampleConcentration === '?????' || sampleConcentration === '>105,000' || sampleConcentration === '<0,000') {
      return 'boxHighlight';
    }
    return 'concentrationOk';
  }

  private textColor(i: number, j: number, carrier: Carrier): string {
    let sampleConcentration = this.getCarrierItemSampleConcentration(i, j, carrier);
    if (sampleConcentration === '?????' || sampleConcentration === '>105,000' || sampleConcentration === '<0,000') {
      return 'errorValue';
    }
    return 'concentrationOk';
  }

  private volumeOk(i: number, j: number, carrier: Carrier): boolean {
    return this.carrierUtil.volumeOk(i, j, carrier);
  }

  private getCarrierItemBarcode(i: number, j: number, carrier: Carrier): string {
    let barcode: string = this.carrierUtil.getCarrierItemBarcode(i, j, carrier);
    if (barcode === null) {
      return '-';
    }
    return barcode;
  }

  private getCarrierItemVolume(i: number, j: number, carrier: Carrier): string {
    return this.carrierUtil.getCarrierItemVolume(i, j, carrier);
  }

  private getCarrierItemTargetVolume(i: number, j: number, carrier: Carrier): string {
    return (Math.round(this.carrierUtil.getCarrierItemTargetVolume(i, j, carrier) * 100) / 100).toString();
  }

  private getTargetVolumeChangeTag(i: number, j: number, carrier: Carrier): boolean {
    return this.carrierUtil.getTargetVolumeChangeTag(i, j, carrier);
  }

  private getCarrierItemForIndex(carrier: Carrier, i: number, j: number): ContainerItem {
    return this.carrierUtil.getCarrierItemForIndex(carrier, i, j);
  }

  private getCarrierItemSampleConcentration(i: number, j: number, carrier: Carrier): string {
    return this.carrierUtil.getCarrierItemSampleConcentration(i, j, carrier);
  }

  onLrsFilePicked(file: ReadFile) {
    this.lrsFileName = file.name;
    this.lrsFileContent = file.content;
  }

  onFlxFilePicked(file: ReadFile) {
    this.flxFileName = file.name;
    this.flxFileContent = file.content;
  }

  onLrsFileReadEnd(fileCount: number) {
    this.status = `Read ${fileCount} file(s) on ${new Date().toLocaleTimeString()}.`;
    this.lrsFilePicker.reset();
  }

  onFlxFileReadEnd(fileCount: number) {
    this.status = `Read ${fileCount} file(s) on ${new Date().toLocaleTimeString()}.`;
    this.flxFilePicker.reset();
  }

  startLiquidLevelDetection() {

    let selectedMachine = new Machine();
    selectedMachine.barcode = this.machineBarcode;
    let hamiltonFile: MachineGeneratedFile = new MachineGeneratedFile(this.lrsFileName, this.lrsFileContent);
    let liquidLevelDetectionRequest: LiquidLevelDetectionRequest = new LiquidLevelDetectionRequest(this.selectedLab.lab, hamiltonFile, selectedMachine);
    this.blocked = true;
    this.reMeasurementTag = false;
    this.reMeasurementSampleCount = 0
    this.reMeasurementFillVolume = 0

    this.ngsVolumeAdjustmentService.liquidLevelDetection(liquidLevelDetectionRequest).subscribe(
      results => {
        console.log("Response is:" + results.data);
        this.liquidLevelDetctionResponse = results.data;
        this.carriers = this.liquidLevelDetctionResponse.carriers;
        this.bufferShow = this.liquidLevelDetctionResponse.allSamplesForConcentrationMeasurementFoundInDatabase;
        if (this.liquidLevelDetctionResponse.buffer !== undefined && this.liquidLevelDetctionResponse.buffer !== null) {
          this.bufferName = this.liquidLevelDetctionResponse.buffer;
        } else {
          this.bufferName = null;
        }
        this.sampleAmount = this.getSampleAmount(this.carriers);
        this.numberOfMeasurements = this.sampleAmount;
        this.fillInVolume = this.getTotalFillVolume(this.carriers);
        this.volumeProblems = this.setAmountOfVolumeProblems(this.carriers);
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Liquid level detection finished', detail: 'Liquid level detection has been successful' });
        this.viewRest = true;
        this.liquidLevelDetctionResponse.allSamplesForConcentrationMeasurementFoundInDatabase = true;
        this.showConcentrationAdjustmentUI = true;
        this.blocked = false;
      },
      error => {
        console.log(error);
        let errMessage = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errMessage);
        this.blocked = false;
      });
  }

  startConcentrationImport() {
    let selectedMachine = new Machine();
    selectedMachine.barcode = this.machineBarcode;
    let flxFile: MachineGeneratedFile = new MachineGeneratedFile(this.flxFileName, this.flxFileContent);
    let liquidConcentrationDetectionRequest: LiquidConcentrationDetectionRequest = new LiquidConcentrationDetectionRequest(this.selectedLab.lab, flxFile, selectedMachine, this.carriers);

    this.ngsVolumeAdjustmentService.liquidConcentrationDetection(liquidConcentrationDetectionRequest).subscribe(
      results => {
        console.log("Response is:" + results.data);
        this.liquidLevelDetctionResponse = results.data;
        this.carriers = this.liquidLevelDetctionResponse.carriers;
        this.sampleAmount = this.getSampleAmount(this.carriers);
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Upload finished', detail: 'Concentration upload has been successful' });
        this.viewRest = true;
        this.concentrationImportForm.reset();
      },
      error => {
        console.log(error);
        let errMessage = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errMessage);
      });
  }

  /**
   * Call to the back-end function to:
   * 1. Validate the FLX Plate Barcode
   * 2. Validate the availability of the FLX Plate
   * 3. Associate the present samples with the selected FLX Plate
   * 4. Generate workfiles (One CSV, One txt)
   * 5. Prompt the download of the Workfiles
   * @memberof NgsVolumeAdjustmentComponent
   */
  validateAndGenerateWorkfile() {
    var currentDate = new Date();
    var dateValue  = this.datePipe.transform(currentDate, 'yy-MM-dd HH:mm');
    var str1 = dateValue.toString().replace(/-/g,'');
    var str2 = str1.toString().replace(/:/g,'');
    var filePrefix = str2.toString().replace(' ','_');
    console.log("Generate Workfile request carriers : " + this.carriers);
    this.ngsWorkfileRequest.barcode = this.flxPlateBarcode;
    this.ngsWorkfileRequest.numberOfMeasureMents = this.numberOfMeasurements;
    this.ngsWorkfileRequest.lab = this.selectedLab.lab;
    this.ngsWorkfileRequest.carrierList = this.carriers;
    this.statusText = 'loading result...';
    this.ngsVolumeAdjustmentService.getWorkfiles(this.ngsWorkfileRequest).subscribe(
      results => {
        this.flxPlateBarcode = '';
        this.showImportConcentrationUI = true;
        console.log('Response is:' + results.data);
        this.ngsWorkfileRespose = results.data;
        this.ngsWorkfileRespose = results.data;
        let csvData = this.ngsWorkfileRespose.csvWorkfile;
        let blobCsv: Blob = new Blob([csvData], { type: 'text/plain' });
        let fileCsv: string = filePrefix + '_Fill_in_FLX.csv';
        saveByFileSaver(blobCsv, fileCsv);

        let txtData = this.ngsWorkfileRespose.txtDataFile;
        let blobTxt: Blob = new Blob([txtData], { type: 'text/plain' });
        let fileTxt: string = filePrefix + '_FLX_EQC.txt';
        saveByFileSaver(blobTxt, fileTxt);
      },
      error => {
        console.log(error);
        const errMessage = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errMessage);
      }
    );
  }

  // TODO join this function with volumeOk-function in carrier-utility.ts
  setAmountOfVolumeProblems(carriers: Carrier[]): number {
    let amountOfVolumeProblems: number = 0;
    carriers.forEach(carrier => {
      if (carrier.containerItems !== undefined && carrier.containerItems !== null) {
        carrier.containerItems.forEach(carrierItem => {
          if (carrierItem.containerItemAware !== undefined && carrierItem.containerItemAware !== null) {
            let sample = carrierItem.containerItemAware;
            if (sample.latestMeasuredVolume.value !== undefined && sample.latestMeasuredVolume.value !== null && sample.libType !== null && sample.latestMeasuredVolume.value > sample.targetVolume) {

              amountOfVolumeProblems++;
            }
          }
        });
      }
    });
    return amountOfVolumeProblems;
  }

  getTotalFillVolume(carriers: Carrier[]): number {
    let totalVolume: number = 0;
    carriers.forEach(carrier => {
      if (carrier.containerItems !== undefined && carrier.containerItems !== null) {
        carrier.containerItems.forEach(carrierItem => {
          if (carrierItem.containerItemAware !== undefined && carrierItem.containerItemAware !== null) {
            let sample = carrierItem.containerItemAware;
            if (sample.latestMeasuredVolume.value !== undefined && sample.targetVolume !== undefined) {
              totalVolume += ( sample.targetVolume - sample.latestMeasuredVolume.value);
            }
          }
        });
      }
    });
    return Math.round(totalVolume * 100) / 100;
  }

  getSampleAmount(carriers: Carrier[]): number {
    let sampleAmount: number = 0;
    carriers.forEach(element => {
      if (element.containerItems !== undefined && element.containerItems !== null) {
        sampleAmount += element.containerItems.length;
      }
    });
    return sampleAmount;
  }

  focusMachinebarcode() {
    document.getElementById('machinebarcode').focus();
  }

  /**
     *
     * Hide the check-box, if sample is not valid
     */
  hiddenSampleIf(carrier: Carrier, i: number) {

    for (let carrierItem of carrier.containerItems) {
      if (carrierItem.positionRow === (i + 1)) {
        return false;
      }
    }
    return true;
  }


  /**
     *
     * Disable check-box, if sample is not active or invalid
     */
  private isSampleActive(i: number, j: number, carrier: Carrier): boolean {
    return this.carrierUtil.isSampleActive(i, j, carrier);
  }

  /**
  * To update selected samples status to inactive
  * On check-box selection, selectedSamples will be updated
  */
  onCheckBoxClick(event, i: number, selectedCarrier: Carrier) {
    for (let carrierItem of selectedCarrier.containerItems) {
      if (carrierItem.positionRow === (i + 1)) {
        var sample: Sample = carrierItem.containerItemAware;
        break;
      }
    }

    if (!event.target.checked) {
      this.carriers.forEach(carrier => {
        if (carrier.containerItems !== undefined && carrier.containerItems !== null) {
          carrier.containerItems.forEach(carrierItem => {
            if (carrierItem.containerItemAware !== undefined && carrierItem.containerItemAware !== null) {
              if (carrierItem.containerItemAware.barcode === sample.barcode) {
                carrierItem.containerItemAware.active = true;
              }
            }
          });
        }
      });
    } else {
      this.carriers.forEach(carrier => {
        if (carrier.containerItems !== undefined && carrier.containerItems !== null) {
          carrier.containerItems.forEach(carrierItem => {
            if (carrierItem.containerItemAware !== undefined && carrierItem.containerItemAware !== null) {
              if (carrierItem.containerItemAware.barcode === sample.barcode) {
                carrierItem.containerItemAware.active = false;
              }
            }
          });
        }
      });
    }
  }


  /**
   * On sample click, show sample details and fields to update sample's target volume
   */
  selectSampleToUpdateTargetVol(event: Event, i: number, carrier: Carrier) {
    //find sample on the table
    for (let carrierItem of carrier.containerItems) {
      if (carrierItem.positionRow === (i + 1)) {
        var sample: Sample = carrierItem.containerItemAware;
        break;
      }
    }

    this.selectedSample = sample;
    this.targetVolume = this.selectedSample.targetVolume;

    this.carriersOfSelectedSamples.push(carrier);

    this.displayDialog = true;
    event.preventDefault();
  }

  /**
   * On save click, update sample's target volume
   */
  updateSampleTargetVol() {
    let ngsUpdateSampleRequest = new NGSUpdateSampleRequestResponse();
    let sample: any = this.selectedSample;
    if (sample.latestMeasuredVolume != null && sample.latestMeasuredVolume.value > this.targetVolume) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Invalid Target Volume', detail: 'Target volume is lesser than Measured volume' });
      return;
    }

    this.selectedSample.volumeChanged = true;
    this.reMeasurementFillVolume += (this.targetVolume - this.selectedSample.targetVolume);
    this.reMeasurementFillVolume = Math.round(this.reMeasurementFillVolume * 100) / 100;
    this.selectedSample.targetVolume = this.targetVolume;
    this.selectedSample.concentrationMeasurementRequired = true;
    this.selectedSamples.push(this.selectedSample);

    ngsUpdateSampleRequest.lab = this.selectedLab.lab;
    ngsUpdateSampleRequest.sampleList = this.selectedSamples;
    ngsUpdateSampleRequest.carrierList = this.carriersOfSelectedSamples;
    ngsUpdateSampleRequest.ngsMeasurementResponse = this.liquidLevelDetctionResponse;

    this.ngsVolumeAdjustmentService.updateSampleTargetVolume(ngsUpdateSampleRequest).subscribe(
      results => {
        if (!results) {
          return;
        }

        if (results.data) {
          ngsUpdateSampleRequest = results.data;
          this.liquidLevelDetctionResponse = ngsUpdateSampleRequest.ngsMeasurementResponse;
          this.carriers = this.liquidLevelDetctionResponse.carriers;
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Updated', detail: 'Target volume is updated successfully' });
          this.onCancelBtnClick();
          this.reMeasurementTag = true;
          this.getReMeasuredSamplesCount();
        }
        console.log("updated sample's target volume:", results);
      },
      error => {
        console.log(error);
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  /**
  * Hide sample details dialog and reset all the properties to null
  */
  onDialogHide() {
    this.selectedSample = null;
    this.targetVolume = null;
    this.selectedSamples = null;
    this.carriersOfSelectedSamples = null;
    console.log("On dialog hide called......");
  }

  /**
   * Hide sample details dialog and reset all the properties to null
   */
  onCancelBtnClick() {
    console.log("Cancel button called......");
    this.targetVolume = null;
    this.selectedSample = null;
    this.selectedSamples = [];
    this.carriersOfSelectedSamples = [];
    this.displayDialog = false;
  }

  //method to count number of re-measured samples
  getReMeasuredSamplesCount(){
    this.reMeasurementSampleCount = 0;
    this.carriers.forEach(carrier => {
      if (carrier.containerItems !== undefined && carrier.containerItems !== null) {
        carrier.containerItems.forEach(carrierItem => {
          if (carrierItem.containerItemAware !== undefined && carrierItem.containerItemAware !== null) {
            if (carrierItem.containerItemAware.volumeChanged) {
              this.reMeasurementSampleCount = this.reMeasurementSampleCount + 1;
            }
          }
        });
      }
    });
  }

  /**Converting numerical concentration to  specified symbols*/
  getConvertedConcentration(concentration: any) {
    if (concentration == null) {
      return '-';
    }
    if (concentration.value == 0) {
      return '-';
    }
    if (concentration.value === -1) {
      return '?????';
    }
    if (concentration.value === -9999999) {
      return '<0,000';
    }
    // Backend returns Float.MAX_VALUE. That comparison here should be ok.
    if (concentration.value === 9999999) {
      return '>105,000';
    }
    return this.carrierUtil.roundOfDecimal(concentration.value);
  }

  //Convert UTC date to Date
  convertDateToString(date: any) {
    let localDate = new Date(date);
    return localDate;
  }

  getCarrierItemBuffer(i, j, carrier) {
    return this.carrierUtil.getCarrierItemBuffer(i, j, carrier);
  }
}
